module.exports = __webpack_public_path__ + "img/025.80186841.png";